
import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllMaintenanceAmountReport  = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/maintenance/amount/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Maintenance Report');
        }
    }
);
export const fetchAllMaintenanceAmountReportMonthly = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/maintenance/monthly/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Maintenance Report');
        }
    }
);
export const fetchAllUpcomingMaintenance = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/maintenance/upcoming`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Maintenance Report');
        }
    }
);